<template>
  <div :class="['news-item', { active }]">
    <div
      class="preview"
      :style="{
        'background-image': `url(${cover ? cover : background})`
      }"
    >
      <div class="overlay">
        <div
          @click="$emit('read', id)"
          class="play"
          :style="{ 'background-image': `url(${playImage})` }"
        />
      </div>
    </div>
    <div class="text">{{ titleText }}</div>
  </div>
</template>

<script>
import { getNewsEntity } from "@/api/api";

export default {
  name: "NewsEntity",
  props: ["id", "title", "cover", "summary", "active"],
  watch: {
    active(nv) {
      nv && this.getDetail();
    }
  },
  data() {
    return { info: null };
  },
  mounted() {
    if (this.active) {
      this.getDetail();
    }
  },
  computed: {
    titleText() {
      const over = this.title.length > 20;
      return `${this.title.substring(0, 20)}${over ? "..." : ""}`;
    },
    playImage() {
      return require("../../assets/images/play_btn@2x.png");
    },
    background() {
      // const name = this.team || "premier_league";
      return require(`../../assets/images/common/bg/${"premier_league"}.jpg`);
    }
  },
  methods: {
    async getDetail() {
      this.info = null;
      // const res = await getNewsEntity(this.id);
      // const { code, data } = res.data;
      // if (code === 200) {
        // this.info = data;
      // }
    }
  }
};
</script>
<style lang="less" scoped>
.news-item {
  opacity: 0;
  transition: 0.16s ease-in-out;
  &.active {
    opacity: 1;
  }
  .preview {
    width: 100%;

    padding-bottom: 44%;
    height: 0;
    position: relative;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    & > .overlay {
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .play {
        width: 2.13333333rem;
        height: 2.13333333rem;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
      }
    }
  }
  .text {
    font-size: 0.271966527rem;
    width: calc(100% - 0.2rem);
    color: #333;
    padding: 0.209205021rem 0.1rem;
    padding-bottom: 0.387029289rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/items/NewsEntity.vue